import React, { Component } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themesAnimated from "@amcharts/amcharts4/themes/animated";
import _ from "lodash";
import languageFile from "../../../public/languages/Translation";

am4core.useTheme(am4themesAnimated);
const COLORS = [
    "#93B9C6", "#0DB14B", "#FCB711", "#F37021", "#CC004C",
    "#6460AA", "#AAAAAA", "#19B2FF", "#9DC62D", "#AF4434", "#93B9C6"
];
class ReviewRatingWaveChart extends Component {
	componentDidMount() {
		this.reviewWaveChart();
	}
	hashStringToColor(str) {
		let hash = 0;
		for (let i = 0; i < str.length; i++) {
			hash = str.charCodeAt(i) + ((hash << 5) - hash);
		}
		let color = "#";
		for (let i = 0; i < 3; i++) {
			let value = (hash >> (i * 8)) & 0xff;
			color += ("00" + value.toString(16)).slice(-2);
		}
		return color;
	}

	formatWaveData = (waveGraphData) => {
		const seenPositions = new Map();
		let formattedData = _.map(waveGraphData, (item, index) => {
			let waveItems = item;
			waveItems["value"] = 376;
			waveItems["id"] = item.locationName;
			waveItems["avgStarRating"] = _.round(item.avgStarRating, 2);

			// 1. Try from props.nodeColorMap
			let locationColor =
				this.props.nodeColorMap &&
				this.props.nodeColorMap[item.locationAddress];

			// 2. Fallback to generated unique color from locationName
			const colorIndex = index % COLORS.length;
			let finalColor = locationColor || COLORS[colorIndex];
 			waveItems["color"] = am4core.color(finalColor);


			const key = `${item.totalReviews}_${item.avgStarRating}`;
			if (seenPositions.has(key)) {
				waveItems["totalReviewsRounded"] = item.totalReviews;
				waveItems["avgStarRatingRounded"] = item.avgStarRating;
				const count = seenPositions.get(key);
				const jitterX = (Math.random() - 0.5) * 2; // small offset ±1
				const jitterY = (Math.random() - 0.5) * 0.2; // small offset ±0.1
				waveItems["totalReviews"] = item.totalReviews + jitterX;

				waveItems["avgStarRating"] = item.avgStarRating + jitterY;
				seenPositions.set(key, count + 1);
			} else {
				waveItems["totalReviews"] = item.totalReviews;
				waveItems["avgStarRating"] = item.avgStarRating;
				waveItems["avgStarRatingRounded"] = Math.round(item.avgStarRating);
				waveItems["totalReviewsRounded"] = Math.round(item.totalReviews);
				seenPositions.set(key, 1);
			}

			return waveItems;
		});

		return formattedData;
	};

	reviewWaveChart() {
		var bubbleChart = am4core.create("wavechart", am4charts.XYChart);
		var valueAxisX = bubbleChart.xAxes.push(new am4charts.ValueAxis());
		valueAxisX.renderer.ticks.template.disabled = true;
		valueAxisX.renderer.axisFills.template.disabled = true;
		// valueAxisX.renderer.grid.template.disabled= true;
		valueAxisX.renderer.axisFills.template.disabled = false;
		// valueAxisX.renderer.axisFills.template.fillOpacity = 0.05;
		valueAxisX.renderer.line.strokeOpacity = 1;
		valueAxisX.renderer.line.strokeWidth = 1;
		valueAxisX.renderer.line.stroke = "#8c8c8c";

		var valueAxisY = bubbleChart.yAxes.push(new am4charts.ValueAxis());
		valueAxisY.renderer.ticks.template.disabled = true;
		valueAxisY.renderer.axisFills.template.disabled = true;
		// valueAxisY.renderer. .template.disabled = true;
		valueAxisY.renderer.axisFills.template.disabled = false;
		valueAxisY.renderer.minGridDistance = 60;
		// valueAxisY.renderer.axisFills.template.fillOpacity = 0.05;
		valueAxisY.renderer.line.strokeOpacity = 1;
		valueAxisY.renderer.line.strokeWidth = 1;
		valueAxisY.renderer.line.stroke = "#8c8c8c";
		valueAxisY.min = 0;
		valueAxisY.max = 6;
		valueAxisY.renderer.labels.template.adapter.add(
			"textOutput",
			function (text, target) {
				if (text.startsWith("6")) {
					return "";
				} else return text;
			},
		);

		var series = bubbleChart.series.push(new am4charts.LineSeries());
		series.dataFields.valueX = "totalReviews";
		series.dataFields.valueY = "avgStarRating";
		series.dataFields.value = "value";
		series.dataFields.color = "color";
		series.dataFields.hidden = "hidden";
		series.strokeOpacity = 0;
		series.sequencedInterpolation = true;
		series.tooltip.pointerOrientation = "vertical";

		var bullet = series.bullets.push(new am4core.Circle());
		bullet.fill = am4core.color("#ff0000");
		bullet.propertyFields.fill = "color";
		bullet.strokeOpacity = 0;
		bullet.strokeWidth = 2;
		bullet.fillOpacity = 0.9;
		bullet.stroke = am4core.color("#ffffff");
		bullet.hiddenState.properties.opacity = 0;
		bullet.tooltipText = `[bold]{locationName}:[/]\n{locationAddress}[/]\n${
			languageFile[localStorage.getItem("language")]["22491"]
		}: {totalReviewsRounded}\n${
			languageFile[localStorage.getItem("language")]["10243"]
		}: {avgStarRatingRounded}`;

		var outline = bubbleChart.plotContainer.createChild(am4core.Circle);
		outline.fillOpacity = 0;
		outline.strokeOpacity = 0.9;
		outline.stroke = am4core.color("#ff0000");
		outline.strokeWidth = 2;
		outline.hide(0);

		var blurFilter = new am4core.BlurFilter();
		outline.filters.push(blurFilter);

		bullet.events.on("over", function (event) {
			var target = event.target;
			outline.radius = target.pixelRadius + 2;
			outline.x = target.pixelX;
			outline.y = target.pixelY;
			outline.show();
		});

		bullet.events.on("out", function (event) {
			outline.hide();
		});

		var hoverState = bullet.states.create("hover");
		hoverState.properties.fillOpacity = 1;
		hoverState.properties.strokeOpacity = 1;

		series.heatRules.push({
			target: bullet,
			min: 2,
			max: 14,
			property: "radius",
		});

		bullet.adapter.add("tooltipY", function (tooltipY, target) {
			return -target.radius;
		});

		bubbleChart.cursor = new am4charts.XYCursor();
		bubbleChart.cursor.behavior = "zoomXY";
		bubbleChart.cursor.snapToSeries = series;

		bubbleChart.scrollbarX = new am4core.Scrollbar();
		bubbleChart.scrollbarY = new am4core.Scrollbar();
		bubbleChart.scrollbarX.disabled = !this.props.showChartZoom;
		bubbleChart.scrollbarY.disabled = !this.props.showChartZoom;
		bubbleChart.data = this.formatWaveData(this.props.waveGraphData);

		// Legend
		bubbleChart.legend = new am4charts.Legend();
		bubbleChart.legend.position = "right";
		bubbleChart.legend.disabled = this.props.showBrandChart;
		var marker = bubbleChart.legend.markers.template.children.getIndex(0);
		marker.cornerRadius(12, 12, 12, 12);
		bubbleChart.logo.disabled = true;
		this.bubbleChart = bubbleChart;
		// this.legendCustomization();
	}
	componentDidUpdate(oldProps) {
		this.bubbleChart.scrollbarX.disabled = !this.props.showChartZoom;
		this.bubbleChart.scrollbarY.disabled = !this.props.showChartZoom;
		this.legendCustomization();
		if (oldProps.waveGraphData !== this.props.waveGraphData) {
			this.bubbleChart.data = this.formatWaveData(this.props.waveGraphData);
		}
	}
	legendCustomization = () => {
		if (!this.props.showBrandChart) {
			this.bubbleChart.legend.data = this.formatWaveData(
				this.props.waveGraphData,
			).map((i) => ({
				name: i.locationName,
				id: i.locationName,
				fill: i.color,
				visible: !i.hidden,
			}));
		} else {
			this.bubbleChart.legend.data = _.uniqBy(
				this.formatWaveData(this.props.waveGraphData),
				"locationName",
			).map((i) => ({
				name: i.locationName,
				id: i.locationName,
				fill: i.color,
				visible: !i.hidden,
			}));
		}
		this.bubbleChart.legend.itemContainers.template.events.on("up", (event) => {
			const id = event.target.dataItem.dataContext.id;
			// this.bubbleChart.data.find(i => i.brandName === id).hidden = !event.target.isActive;
			_.map(this.bubbleChart.data, (i, key) => {
				if (i.locationName === id) {
					this.bubbleChart.data[key].hidden = !event.target.isActive;
				}
			});
			this.bubbleChart.validateData();
		});
		this.bubbleChart.legend.itemContainers.template.events.on(
			"hit",
			(event) => {
				const id = event.target.dataItem.dataContext.id;
				// this.bubbleChart.data.find(i => i.brandName === id).hidden = !event.target.isActive;
				_.map(this.bubbleChart.data, (i, key) => {
					if (i.locationName === id) {
						this.bubbleChart.data[key].hidden = !event.target.isActive;
					}
				});
				this.bubbleChart.validateData();
			},
		);
	};
	// renderGraphWidth = () => {
	//     if (this.props.showBrandChart) {
	//         return "1070px";
	//     } else {
	//         return "830px";
	//     }

	render() {
		return (
			<div
				className="nightmare-wavechart"
				id="wavechart"
				style={{ width: "100%", height: "100%", margin: "0 auto" }}></div>
		);
	}
}
export default ReviewRatingWaveChart;
